// -------------------------------------------- IMPORT FILES START --------------------------------------------------------------
// ## Import Files
import $api from "../../Api";
import ResponseChecker from "../../Middlewares/ResponseChecker";
import { defaultMessages } from "../../enums/responseMessages.js";

import Endpoints from "../../Endpoints";

// -------------------------------------------- IMPORT FILES ENDED --------------------------------------------------------------

// ## MobileApp.Topics Get
/**
 *
 * @param {{params: object, query: { paymentMethodId: string }}} option
 *
 * @returns
 */
export const GetAll = async (option) => {
  const response = await $api.get(Endpoints.MobileApp.Topics.GetAll(option));
  const checker = await ResponseChecker(defaultMessages, response);

  return checker;
};
// ## MobileApp.Topics Create
/**
 *
 * @param {{ paymentMethodId: string, MobileApp.TopicsRate: number }} form
 *
 * @returns
 */
export const Create = async (form) => {
  const response = await $api.post(Endpoints.MobileApp.Topics.Create(), form);
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## MobileApp.Topics Get ById
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const GetById = async (option) => {
  const response = await $api.get(Endpoints.MobileApp.Topics.GetById(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## MobileApp.Topics Update
/**
 *
 * @param {{ paymentMethodId: string, MobileApp.TopicsRate: number, isActive: boolean }} form
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Update = async (form, option) => {
  const response = await $api.put(
    Endpoints.MobileApp.Topics.Update(option),
    form
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## MobileApp.Topics Delete
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Delete = async (option) => {
  const response = await $api.delete(Endpoints.MobileApp.Topics.Delete(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## MobileApp.Topics Add Money Point For Customers
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const GetTopicItemTypes = async (option) => {
  const response = await $api.get(
    Endpoints.MobileApp.Topics.GetTopicItemTypes(option)
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## MobileApp.Topics Add Money Point For Customers
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const UpdateTopicOrders = async (form, option) => {
  const response = await $api.put(
    Endpoints.MobileApp.Topics.UpdateTopicOrders(option),
    form
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

export default {
  GetAll,
  Create,
  GetById,
  Update,
  Delete,
  GetTopicItemTypes,
  UpdateTopicOrders,
};
